import { createContext, Dispatch, SetStateAction } from 'react'
import { Rect } from '../../types/diagram.ts'

export const DiagramViewPortContext = createContext({
    viewPort: { x: 0, y: 0, width: 0, height: 0 } as Rect,
    initialViewPort: { x: 0, y: 0, width: 0, height: 0 } as Rect,
    zoom: 1,
    container: undefined as SVGSVGElement | undefined,
    htmlContainer: undefined as HTMLElement | undefined
})

export const CustomizeDiagramViewPortContext = createContext({
    setInitialViewPort: (() => { }) as Dispatch<SetStateAction<Rect>>,
    setViewPort: (() => { }) as Dispatch<SetStateAction<Rect>>,
    resetViewPort: (() => { }),
    setZoom: (() => { }) as Dispatch<SetStateAction<number>>,
    zoomIn: (() => { }),
    zoomOut: (() => { }),
    setContainer: (() => { }) as Dispatch<SetStateAction<SVGSVGElement | undefined>>,
    setHTMLContainer: (() => { }) as Dispatch<SetStateAction<HTMLElement | undefined>>
})
